export default __webpack_public_path__ + "static/media/screen8.211aab36.png";